import _orderBy from 'lodash/orderBy';
import { parseJSON_ifParsable, transformApiResponse } from 'utils/objectManipulate';
import parseAnimationSettings from 'utils/parseAnimationSettings';
import { gameTypes, isPurePrizeGames } from 'config/promoGameTypes';

export async function normalizePromoTasksList(list = []) {
    const orderedList = _orderBy(list, ['seq']);

    const result = {
        allUUIDs: [],
        byUUIDs: {},
        settingsByUUIDS: {},
        optionsByUUIDS: {},
        relationByUUIDS: {}
    };

    for (const d of orderedList) {
        result.allUUIDs.push(d.uuid);
        const [main, settings, taskOption, styles, promotions] = normalizePromoTaskData(d);
        result.byUUIDs[d.uuid] = main;
        result.settingsByUUIDS[d.uuid] = {
            ...settings,
            ...styles
        };
        result.optionsByUUIDS[d.uuid] = taskOption;
        result.relationByUUIDS[d.uuid] = {
            uuid: promotions?.uuid
        };
    }

    return result;
}

function normalizePromoTaskData(data) {
    const {
        settings: {
            PromotionOptions: { uuid: optionUUIDS } = {},
            Task,
            Tasks,
            Styles = {},
            Promotions = {}
        } = {},
        ...rest
    } = data;
    const task = Tasks || Task || {};

    const convertedTask = transformApiResponse(task, {
        prefixes: ['enable'],
        suffixes: ['Type, id', 'Id'],
        Constructor: Number
    });
    const convertedStyles = transformApiResponse(Styles, {
        prefixes: ['enable'],
        suffixes: ['Type', 'id', 'Id'],
        Constructor: Number
    });

    return [
        rest,
        convertedTask,
        parseJSON_ifParsable(optionUUIDS, []),
        convertedStyles,
        Promotions
    ];
}

export function normalizePromoLotteryList(list = []) {
    return list.reduce((obj, data) => {
        const {
            lottery: { type, uuid, prizeTaskFilter } = {},
            lotterySetting: {
                Lotteries: { showRest = 0, entryLotteryLimit, suspendWhenNoPrize } = {},
                AnimationSettings,
                Tasks: TasksSetting = {}
            } = {},
            prizeLimited,
            prizeRemainder
        } = data;
        obj[uuid] = {
            type,
            showRest,
            remainder: prizeRemainder,
            suspendWhenNoPrize,
            prizeLimited,
            entryLotteryLimit,
            AnimationSettings: parseAnimationSettings(AnimationSettings, type),
            TasksSetting,
            prizeTaskFilter
        };
        return obj;
    }, {});
}

// [#86entxjdp] 空 formbased 模組強制不 create form
export function canNotRetrieveFormData(formId, gameType) {
    if (!formId || isPurePrizeGames(gameType) || gameType === gameTypes.SIGN_FORM) {
        return true;
    }
    return false;
}

export const tryCatch = (promise, errorTypes = []) =>
    promise
        .then(response => [null, response])
        .catch(error => {
            const shouldCatch =
                errorTypes.length === 0 || errorTypes.some(type => error instanceof type);
            return shouldCatch ? [error, null] : Promise.reject(error);
        });

export const preProcessAwardeeForm = (awardeeForm, awardedFormSettings = {}) => {
    const awardedFormList = awardedFormSettings.list ? JSON.parse(awardedFormSettings.list) : [];
    return awardeeForm.map(form => {
        const awardedFormInfo = awardedFormList.find(f => f.id === form.id);
        return {
            ...form,
            ...(awardedFormInfo ?? {})
        };
    });
};
